{
  "name": "ir-ng-fe",
  "version": "1.2.2-develop.0",
  "scripts": {
    "watch": "ng test",
    "build": "./scripts/version.sh && ng build --output-hashing all",
    "install": "cp ./package.json ./src/assets",
    "lint": "ng lint",
    "ng": "ng",
    "start": "cp ./package.json ./src/assets && ng serve --ssl --host localhost.sparbanken.me",
    "style-lint": "stylelint  src/**/*.scss --fix",
    "test": "ng test"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^22.0.6",
    "@angular/cdk": "^22.0.4",
    "@angular/common": "^22.0.6",
    "@angular/compiler": "^22.0.6",
    "@angular/core": "^22.0.6",
    "@angular/forms": "^22.0.6",
    "@angular/material": "^22.0.4",
    "@angular/platform-browser": "^22.0.6",
    "@angular/platform-browser-dynamic": "^22.0.6",
    "@angular/router": "^22.0.6",
    "rxjs": "~7.8.2",
    "tslib": "^2.8.1"
  },
  "devDependencies": {
    "@angular/build": "^22.0.5",
    "@angular/cli": "^22.0.5",
    "@angular/compiler-cli": "^22.0.6",
    "@aws-sdk/client-lambda": "^3.1033.0",
    "@eslint/js": "^10.0.1",
    "@sparbanken-syd/auth-backend": "^2.6.5",
    "@sparbanken-syd/bv-api": "^1.0.3",
    "@sparbanken-syd/personnummer": "^3.0.1",
    "@sparbanken-syd/sparbanken-syd-bankid": "^22.0.0",
    "@sparbanken-syd/sparbanken-syd-qr": "^22.0.0",
    "@sparbanken-syd/sparbanken-syd-theme": "^22.0.1",
    "@sparbanken-syd/sparbanken-syd-theme-m3": "^22.0.0",
    "@types/node": "^24.0.0",
    "@vitest/coverage-v8": "^4.1.9",
    "angular-eslint": "^22.0.0",
    "aws-sdk-client-mock": "^4.1.0",
    "echarts": "^6.1.0",
    "eslint": "^10.2.1",
    "jsdom": "^29.1.1",
    "ngx-echarts": "^21.0.0",
    "stylelint": "^17.8.0",
    "stylelint-config-sass-guidelines": "^13.0.0",
    "stylelint-config-standard-scss": "^17.0.0",
    "typescript": "~6.0.3",
    "typescript-eslint": "^8.59.0",
    "vitest": "^4.1.9"
  }
}
